import { CircularProgress, ListItemIcon, ListItemText, Theme, WithStyles, createStyles, withStyles } from '@material-ui/core';
import { IconDefinition, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import React, { Fragment } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ListItem from '@material-ui/core/ListItem';
import classnames from 'classnames';

interface Props extends WithStyles<typeof styles> {
  loading: boolean
  icon: IconDefinition
  name: string
  description: string
  isRequired: boolean
  isEnrolled: boolean
  onClick: () => void
}

const styles = (theme: Theme) => createStyles({
  buttonContainer: {
    position: 'relative',
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`
  },
  clickable: {
    cursor: 'pointer',
  },
  chevron: {
    color: theme.palette.grey[600],
    marginLeft: theme.spacing(2),
  },
  loadingModal: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1,
    backgroundColor: 'rgba(255, 255, 255, 0.8)'
  },
})

const getTooltip = (isRequired: boolean, isEnrolled: boolean): string => {
  let required = (isRequired ? '' : 'not ') + 'required'
  let enrolled = (isEnrolled ? '' : 'not ') + 'enrolled'

  let arr = [required, enrolled]
  //if(isEnrolled && !isRequired)
  //  arr = arr.reverse()

  let str = arr.join(', ')
  return str.charAt(0).toUpperCase() + str.slice(1)
}

const AuthButtonComponent: React.FC<Props> = ({ loading, icon, description, isEnrolled, isRequired, classes, onClick }) => {
  return (
    <Fragment>
      <ListItem button disabled={!isEnrolled || !isRequired} className={classnames(classes.buttonContainer, { [classes.clickable]: isEnrolled && isRequired })} onClick={isEnrolled && isRequired ? onClick : () => null}>
        <ListItemIcon>
          <FontAwesomeIcon icon={icon} size="2x" fixedWidth />
        </ListItemIcon>
        <ListItemText inset primary={description} secondary={getTooltip(isRequired, isEnrolled)} />
        {isEnrolled && isRequired &&
          <FontAwesomeIcon icon={faChevronRight} size="1x" className={classes.chevron} />
        }
        {loading &&
          <div className={classes.loadingModal}>
            <CircularProgress />
          </div>
        }
      </ListItem>
      {/*<Divider />*/}
    </Fragment>
  )
}

export default withStyles(styles)(AuthButtonComponent)
